import { render, staticRenderFns } from "./Backlink.vue?vue&type=template&id=f5d2fb5e&functional=true"
import script from "./Backlink.vue?vue&type=script&lang=js"
export * from "./Backlink.vue?vue&type=script&lang=js"
import style0 from "./Backlink.vue?vue&type=style&index=0&id=f5d2fb5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports